import { getToken, setToken, removeToken } from '@/utils/auth'
import { getLoginApi } from '@/api/login.js'
import { Toast } from 'vant'
import router from '@/router'
import Cookies from 'js-cookie'
import { getInfo } from '@/api/login'
const getDefaultState = () => {
  return {
    token: getToken(),
    active: Cookies.get('active') || 0,
    avatarurl: Cookies.get('avatarurl') || 0,
    role: Cookies.get('role') || 0,
    rolename: Cookies.get('rolename') || 0,
    nickname: Cookies.get('nickname') || '',
    opPicUrl: Cookies.get('opPicUrl') || ''
  }
}

const state = getDefaultState()

const mutations = {
  // 设置token
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ACTIVE: (state, active) => {
    state.active = active
    Cookies.set('active', active)
  },
  SET_AVATARURL: (state, avatarurl) => {
    state.avatarurl = avatarurl
    Cookies.set('avatarurl', avatarurl)
  },
  SET_ROLE: (state, role) => {
    state.role = role
    Cookies.set('role', role)
  },
  SET_ROLENAME: (state, rolename) => {
    state.rolename = rolename
    Cookies.set('rolename', rolename)
  },
  SET_NICKNAME: (state, nickname) => {
    state.nickname = nickname
    Cookies.set('nickname', nickname)
  },
  SET_OPPICURL: (state, opPicUrl) => {
    state.opPicUrl = opPicUrl
    Cookies.set('opPicUrl', opPicUrl)
  }
}

const actions = {
  login({ commit, dispatch }, payload) {
    const { username, password, verifyCode } = payload
    return new Promise((resolve, reject) => {
      getLoginApi({ username: username, password: password, verifyCode: verifyCode })
        .then((response) => {
          if (response === undefined) {
            reject()
            return
          } else {
            const { data, code } = response
            commit('SET_TOKEN', data.token)
            commit('SET_AVATARURL', data.avatarUrl)
            commit('SET_ROLE', data.role)
            commit('SET_ROLENAME', data.roleName)
            commit('SET_NICKNAME', data.nickname)
            setToken(data.token)
            router.replace('/')
            resolve()
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state, token).then(response => {
            commit('SET_AVATARURL', response.data.avatarUrl)
            commit('SET_ROLE', response.data.role)
            commit('SET_ROLENAME', response.data.roleName)
            commit('SET_NICKNAME', response.data.nickname)
            resolve()
      }).catch(err => {
        reject(err)
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
